import { PureComponent } from "react"
import { Mutation, Query } from "react-apollo"
import Composer from "react-composer"
import Head from "../../../components/head-data/head-data"
import gql from "graphql-tag"
import { perPage } from "../../../config"
import IdeasDetails from "../../../components/idea-details/idea-details"
import PagePopup from "../../../components/page-popup/page-popup"
import AdditionalDetails from "../../../containers/user-grid/additional-details"
import { LOCAL_TOGGLE_IDEA_USER_DETAILS } from "../../../apollo-state/graphql/mutations"
import { LOCAL_UI_QUERY } from "../../../apollo-state/graphql/queries"
import "../../../containers/user-grid/user-grid"


export const USER_LOCKING_FOR_IDEAS = gql`
  query ideas(
    $skip: Int = 0
    $perPage: Int = 10
    $savesWhere: IdeaSaveWhereInput
    $likesWhere: IdeaLikeWhereInput
    $ideaId: ID
    $myId: ID = null
  ) {
    usersLookingForIdea(skip: $skip, perPage: $perPage, ideaId: $ideaId) {
      title
      id
      elevatorPitch
      totalLikes
      totalComments
      totalSaves
      isActive
      createdBy {
        firstName
        profilePic
        id
        location
        role
        hasValidCoFounderSubscription
        whyMakeGoodCofounder
        lookingToJoinStartupAsFounder
        hasIdeaForStartup
        elevatorPitchForStartup
        knowledgePoints
        activityStatus
        lastActive
       ideas{
      title
      id
      elevatorPitch
      totalLikes
      totalComments
      totalSaves
      isActive
      ideaIndustry {
        id
        itemId
        label
      }
      ideaStage {
        id
        itemId
        label
      }
      saves {
        id
        user {
          id
        }
      }
      likes {
        id
        user {
          id
        }
        } 
      }
        addedBy(where: { id: $myId }) {
          id
        }
        hoursPerWeekAvailable {
          id
          label
        }
        ideaStage {
          id
          label
        }
        ideaIndustry {
          id
          label
        }
        hasSkills {
          id
          label
        }
        wantsSkills {
          id
          label
        }
        startupIndustry {
          id
          label
          itemId
        }
        startupStage {
          id
          label
          itemId
        }
      }
      ideaIndustry {
        id
        itemId
        label
      }
      ideaStage {
        id
        itemId
        label
      }
      saves(where: $savesWhere) {
        id
      }
      likes(where: $likesWhere) {
        id
        user {
          id
        }
      }
    }
  }
`
class Index extends PureComponent {
  constructor(props) {
    super(props)
  }
  render() {
    const { query, me } = this.props
    const variables = {
      skip: 0,
      perPage,
      savesWhere: me?.id ? { user: { id: me?.id } } : {},
      likesWhere: me?.id ? { user: { id: me?.id } } : {},
      ...(query.id ? { ideaId: query.id } : {}),
      myId: me?.id || null,
    }
    return (
      <>
        <Composer
          components={[
            ({ render }) => <Query query={LOCAL_UI_QUERY}>{render}</Query>,
          ]}
        >
          {([uiState]) => {
            return (
              <>
                <Head />
                <Query query={USER_LOCKING_FOR_IDEAS} variables={variables}>
                  {({ data, error, loading }) => {
                    if (loading) return <div className="general-loading" />
                    if (error)
                      return (
                        <>
                          <Head
                            title={`Profile not available`}
                            description={`Profile not available`}
                            url={`https://www.foundercloud.com/ideas/${query.id}`}
                          />
                          <p style={{ marginTop: "40px" }}>
                            {error.message.replace("GraphQL error: ", "")}
                          </p>
                        </>
                      )
                    return (
                      <>
                        <Head
                          title={`${data?.usersLookingForIdea?.[0]?.createdBy?.firstName || 'Unknown'}'s idea`}
                          description={`${data?.usersLookingForIdea?.[0]?.createdBy?.firstName || 'Unknown'}'s idea`}
                          url={`https://www.foundercloud.com/ideas/${query.id}`}
                        />
                        <IdeasDetails
                          data={data?.usersLookingForIdea[0] || []}
                          me={me}
                        />
                        <Mutation mutation={LOCAL_TOGGLE_IDEA_USER_DETAILS}>
                          {(toggle) => (
                            <>
                              {uiState.data.ui.ideaUserDetailsPopup && (
                                <PagePopup togglePopup={toggle}>
                                  <AdditionalDetails
                                    me={me || {}}
                                    {...(data?.usersLookingForIdea[0]
                                      ?.createdBy || {})}
                                  // signupOverlayActive={signupOverlayActive}
                                  />
                                </PagePopup>
                              )}
                            </>
                          )}
                        </Mutation>
                      </>
                    )
                  }}
                </Query>
              </>
            )
          }}
        </Composer>
      </>
    )
  }
}

export default Index
